"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAllowedDecimalPlaces = void 0;
var DEFAULT_CURRENCY_DECIMALS = 2;
var findAllowedDecimalPlaces = function (currency, _a) {
    var currenciesConfig = _a.currenciesConfig;
    if (!currenciesConfig) {
        throw new Error('currenciesConfig need to be defined');
    }
    // default to 2
    if (!currency) {
        return DEFAULT_CURRENCY_DECIMALS;
    }
    var result = currenciesConfig.find(function (_a) {
        var code = _a.code;
        return code === currency;
    }) || {};
    return result.decimalPlaces !== undefined ? result.decimalPlaces : DEFAULT_CURRENCY_DECIMALS;
};
exports.findAllowedDecimalPlaces = findAllowedDecimalPlaces;
//# sourceMappingURL=decimal-places.js.map